import i18n from '../i18n';
import { getSetting, setSetting, settingKeys } from './settings';

const ENABLE_SUBSCRIPTION = false;

export const SUBSCRIPTION_ENABLED = ENABLE_SUBSCRIPTION && process.env.NODE_ENV === 'development';

export const FREE_SONG_LIMIT = 10;
export const YEARLY_PRICE = 29.99;
// Read when shown, so it follows the app language
export const getYearlyPriceLabel = () => i18n.t('subscription.perYear', { price: `$${YEARLY_PRICE.toFixed(2)}` });
export const FREE_PUBLIC_SONG_ADDS_PER_DAY = 1;

// The JWT doesn't carry subscription state yet (payments aren't wired up), so this reads
// as false for everyone. Keep the check here so there's one place to update once the
// backend starts sending it.
export const isSubscribed = (user) => !!user?.isSubscribed;

export const hasReachedLimit = (songs) => {
  if (!Array.isArray(songs)) return false;
  return songs.length >= FREE_SONG_LIMIT;
};

const todayKey = () => new Date().toLocaleDateString('en-CA');

export const canAddPublicSongToday = () => {
  const last = getSetting(settingKeys.lastPublicSongAddedDate);
  return last !== todayKey();
};

export const markPublicSongAdded = () => {
  setSetting(settingKeys.lastPublicSongAddedDate, todayKey());
};
